import { useCallback } from 'react'

import { useFloorStore } from '../../../../map-editor-shared/store/floorStore'
import { useCsvRuntimeStore } from '../../../../map-editor-features/csv/model/csvStore'
import {
  mapDataGetCsvFileName,
  mapDataGetCsvGroupedLayers,
  mapDataGetCsvParsed,
  mapDataGetCsvRaw,
  mapDataGetCsvSelectedLayers,
} from '../../../../map-editor-shared/store/mapDataCsvHelpers'

interface UseFloorRestorationReturn {
  restoreFloorCSVState: (floorId: string) => void
}

export function useFloorRestoration(): UseFloorRestorationReturn {
  const { floors } = useFloorStore()

  // ======================
  // Helper: Restore floor CSV state (for modal integration)
  // ======================
  const restoreFloorCSVState = useCallback(
    (floorId: string) => {
      const floorData = floors.find(f => f.id === floorId)

      const md = floorData?.mapData
      const csvRaw = mapDataGetCsvRaw(md)
      if (csvRaw) {
        useCsvRuntimeStore.getState().mergeCsvRuntimeForFloor(floorId, {
          uploadState: {
            status: 'parsed',
            fileName: mapDataGetCsvFileName(md) || 'Restored Data',
            rowCount: (mapDataGetCsvParsed(md) as { rowCount?: number } | null)?.rowCount || 0,
            isRestored: true,
          },
          rawData: csvRaw,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any -- merged mapData may be legacy or migrated CSV shape
          parsedData: (mapDataGetCsvParsed(md) as any) ?? null,
          groupedLayers: mapDataGetCsvGroupedLayers(md),
          selectedLayers: new Set(mapDataGetCsvSelectedLayers(md)),
          file: null,
        })
      } else {
        useCsvRuntimeStore.getState().mergeCsvRuntimeForFloor(floorId, {
          uploadState: { status: 'idle' },
          file: null,
          rawData: null,
          parsedData: null,
          groupedLayers: null,
          selectedLayers: new Set<string>(),
        })
      }
    },
    [floors]
  )

  return {
    restoreFloorCSVState,
  }
}
